<template>
  <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M5.76091 6.29135C7.49822 6.29135 8.90659 4.88299 8.90659 3.14568C8.90659 1.40837 7.49822 0 5.76091 0C4.0236 0 2.61523 1.40837 2.61523 3.14568C2.61523 4.88299 4.0236 6.29135 5.76091 6.29135Z"
        fill="currentColor"/>
    <path
        d="M2.28205 6.83615L1.24316 9.09491C1.05874 9.60882 1.30297 10.2277 1.78847 10.4777L5.09725 11.7979C5.5827 12.0478 6.38014 12.0685 6.87818 11.8444L10.2658 10.4312C10.7636 10.207 10.9624 9.63304 10.7095 9.14909L9.3653 6.7818C9.11244 6.29807 8.60672 6.23872 8.14622 6.53239C7.61304 6.87251 6.80847 7.22399 5.76162 7.22399C4.71477 7.22399 3.9102 6.87251 3.37703 6.53262C2.91657 6.23895 2.46643 6.32225 2.28205 6.83615Z"
        fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: "IconAgent"
}
</script>

<style scoped>

</style>